"use client"

import { useEffect } from "react"
import { useEcomStore } from "@/context/ecom/EcomContext"
import { EcommerceState, EcomDispatch } from "@/types/ecom"

interface ClientDataInitializerProps {
  // Not the full store state — just the merged productDetailLabels +
  // ecomErrorMessages payload dispatched as globalEcommerceLabels.
  ecomSettings: Partial<EcommerceState>
  skuCountryExclusions?: Record<string, string[]> | null
}

export default function ClientDataInitializer({
  ecomSettings,
  skuCountryExclusions,
}: ClientDataInitializerProps): null {
  const [_state, dispatch] = (useEcomStore() ?? []) as
    | [EcommerceState, EcomDispatch]
    | []

  useEffect(() => {
    if (ecomSettings && dispatch) {
      dispatch({ type: "SET_GLOBAL_ECOMMERCE_LABELS", payload: ecomSettings })
    }
  }, [ecomSettings, dispatch])

  useEffect(() => {
    if (skuCountryExclusions && dispatch) {
      dispatch({
        type: "SET_SKU_COUNTRY_EXCLUSIONS",
        payload: skuCountryExclusions,
      })
    }
  }, [skuCountryExclusions, dispatch])

  return null
}
